module.exports = __webpack_public_path__ + "static/media/lc.2eb42ccb.svg";